export class QrefPidTerUchModel {
  code: string;
  description: string;

  constructor() {
  }
}

